import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { PagesContext } from '../store/PagesContext';
import { setItemToLocalStorage } from 'helpers/localStorage';

import OList from 'components/Lists/OList';

import purplePolygon from '../assets/images/svg/purple-polygon.svg';

const NsoD = ({ setCurrentPage }) => {
  const [, setLastPage] = useContext(PagesContext);

  const optionOneHandler = () => {
    setItemToLocalStorage('EcameFrom', 'nsoD');
    setLastPage('nsoD');
    setCurrentPage('nsoE');
  };
  const optionTwoHandler = () => setCurrentPage('nsoF');
  const optionThreeHandler = () => setCurrentPage('nsoG');

  useEffect(() => setLastPage('nsoB'), []);

  return (
    <>
      <div className='mw-700 m-auto with-right-corner py-sm-5'>
        <h1 className='page-heading text-center mb-5'>
          Great! <br />
          What do you intend to do with your stocks?
        </h1>

        <OList>
          <li onClick={optionOneHandler}>I intend to hold onto my stocks and sell at a later date.</li>
          <li onClick={optionTwoHandler}>My company has allowed me to cash out pre-IPO.</li>
          <li onClick={optionThreeHandler}>I&apos;m waiting for my company to IPO and, after the lockup period, I will sell.</li>
        </OList>
      </div>

      <img src={purplePolygon} className='corner-purple-top-right' alt='' />
    </>
  );
};

NsoD.propTypes = {
  setCurrentPage: PropTypes.func
};

export default NsoD;
